import { Box, Flex, Icon, Text, Tooltip, TruncatedText } from "@nulogy/components";
import HalfField from "components/common/HalfField";
import { formatQuantity } from "components/helpers/format";
import React from "react";

const EffectiveProductionRateInfo = () => {
  const tooltip =
    "Effective production rate is calculated by multiplying the production rate by the item performance, labor ratio, and line efficiency (if applicable).";

  return (
    <Tooltip tooltip={tooltip}>
      <Icon color="black" icon="info" size="20px" />
    </Tooltip>
  );
};

export default function ProductionDetailsSummary({ effectiveProductionRate, expectedQuantity, unitOfMeasure }) {
  return (
    <Box marginTop="x2">
      <Flex gap="x2">
        <HalfField>
          <Flex alignItems="center" gap="half">
            <Text fontSize="small" fontWeight="bold">
              Effective production rate
            </Text>
            <EffectiveProductionRateInfo />
          </Flex>
        </HalfField>
        <HalfField className="spec-effective-production-rate">
          <Flex gap="half">
            <TruncatedText fontSize="small">{formatQuantity(effectiveProductionRate).toString()}</TruncatedText>
            <Text fontSize="small">{unitOfMeasure}/hour</Text>
          </Flex>
        </HalfField>
      </Flex>
      <Flex gap="x2">
        <HalfField marginBottom={0}>
          <Text fontSize="small" fontWeight="bold">
            Expected block quantity
          </Text>
        </HalfField>
        <HalfField className="spec-expected-quantity" marginBottom={0}>
          <Flex gap="half">
            <TruncatedText fontSize="small">{formatQuantity(expectedQuantity).toString()}</TruncatedText>
            <Text fontSize="small">{unitOfMeasure}</Text>
          </Flex>
        </HalfField>
      </Flex>
    </Box>
  );
}
